"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItemContent = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _MenuItemIcon = require("./MenuItemIcon");
var _MenuPropTypes = require("./MenuPropTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MenuItemContent = _ref => {
  let {
    itemDefinition,
    renderRightIcon = true,
    isHoverTrigger
  } = _ref;
  const {
    icons,
    isOpen,
    label,
    hideLabel
  } = itemDefinition;
  const hasIcons = typeof icons !== 'undefined';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hasIcons && (0, _MenuItemIcon.MenuItemIcon)({
    icon: icons.left,
    isOpen,
    isHoverTrigger
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(hideLabel ? 'sr-only' : 'labelText')
  }, label), hasIcons && renderRightIcon && (0, _MenuItemIcon.MenuItemIcon)({
    icon: icons.right,
    isOpen,
    isHoverTrigger
  }));
};
exports.MenuItemContent = MenuItemContent;
MenuItemContent.propTypes = {
  itemDefinition: _propTypes.default.shape(_MenuPropTypes.MenuButtonPropTypes),
  renderRightIcon: _propTypes.default.bool,
  isHoverTrigger: _propTypes.default.bool
};